import React from 'react'
import HouseProperty from './HouseProperty'

const HousePropertyPage = () => {
  return (
    <div>
      <HouseProperty />
    </div>
  )
}

export default HousePropertyPage
